var _g, _g2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAndroidLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "-147 -70 294 345",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#a4c639"
  }, /*#__PURE__*/React.createElement("use", {
    strokeWidth: 14.4,
    xlinkHref: "#b",
    stroke: "#FFF"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a",
    transform: "scale(-1,1)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "a",
    stroke: "#FFF",
    strokeWidth: 7.2
  }, /*#__PURE__*/React.createElement("rect", {
    rx: 6.5,
    transform: "rotate(29)",
    height: 86,
    width: 13,
    y: -86,
    x: 14
  }), /*#__PURE__*/React.createElement("rect", {
    id: "c",
    rx: 24,
    height: 133,
    width: 48,
    y: 41,
    x: -143
  }), /*#__PURE__*/React.createElement("use", {
    y: 97,
    x: 85,
    xlinkHref: "#c"
  })), /*#__PURE__*/React.createElement("g", {
    id: "b"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cy: 41,
    rx: 91,
    ry: 84
  }), /*#__PURE__*/React.createElement("rect", {
    rx: 22,
    height: 182,
    width: 182,
    y: 20,
    x: -91
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    stroke: "#FFF",
    strokeWidth: 7.2,
    fill: "#FFF"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m-95 44.5h190"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: -42,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 42,
    r: 4
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAndroidLogo);
export default __webpack_public_path__ + "static/media/android-logo.b1a4d48c0f657e6d78de0c6e9011872f.svg";
export { ForwardRef as ReactComponent };